import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { asyncUsersActions } from './thunks';
import { User } from 'types/user';

export interface UsersState {
  users: User[];
  isLoading: boolean;
  onlineUsersIds: string[];
}

export const initialState: UsersState = {
  users: [],
  isLoading: false,
  onlineUsersIds: [],
};

export const slice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    addOnlineUsersIds: (state, { payload }: PayloadAction<string[]>) => {
      state.onlineUsersIds = Array.from(new Set([...state.onlineUsersIds, ...payload]));
    },
    removeOnlineUserId: (state, { payload }: PayloadAction<string>) => {
      state.onlineUsersIds = state.onlineUsersIds.filter((id) => id !== payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(asyncUsersActions.getUsers.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(asyncUsersActions.getUsers.fulfilled, (state, { payload }) => {
        state.users = payload;
        state.isLoading = false;
      });
  },
});

export const usersActions = { ...slice.actions, ...asyncUsersActions };
export const usersReducer = slice.reducer;
